/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-nested-ternary */
import React from 'react';
import {
  ChevronDownIconSmall,
  ChevronRightIconSmall,
} from '@domain-group/fe-co-icon';
import VersionChooser from './version-chooser';
import SearchBox from './search/search-box';
import * as styles from './navigation.styles';
import { NavigationPage } from '../lib/docs-api';

function renderNavigationMenu(version: string, items: NavigationPage[]) {
  return items.map((page) => {
    let drawIcon: 'none' | 'expanded' | 'collapsed' = 'none';
    if (page.icon === 'folder') {
      drawIcon = 'collapsed';
    }
    if (page.icon === 'folder' && page.children?.length > 0) {
      drawIcon = 'expanded';
    }
    return (
      <li css={styles.navMenuItem} key={page.path}>
        {(page.isPage && (
          <>
            <div css={styles.icon}>
              {drawIcon === 'expanded' ? (
                <ChevronDownIconSmall size="custom" />
              ) : drawIcon === 'collapsed' ? (
                <ChevronRightIconSmall size="custom" />
              ) : (
                <></>
              )}
            </div>
            <a
              css={styles.navLink(page.isCurrent, drawIcon !== 'none')}
              title={page.title}
              href={`/docs/${encodeURIComponent(version)}/${page.path}/`}
            >
              {page.title}
            </a>
          </>
        )) || <div css={styles.subNavHeading}>{page.title}</div>}
        {page.children && (
          <ul css={styles.subNavMenu(!page.isPage)}>
            {renderNavigationMenu(version, page.children)}
          </ul>
        )}
      </li>
    );
  });
}

interface NavigationProps {
  version: string;
  documentList: NavigationPage[];
}

// eslint-disable-next-line react/prefer-stateless-function
export default class Navigation extends React.Component<NavigationProps> {
  render(): React.ReactNode {
    const { documentList, version } = this.props;
    return (
      <div
        id="table-of-contents"
        role="navigation"
        aria-label="Table of Contents"
        css={styles.navigationContainer}
      >
        <h4 css={styles.navigationTitle}>Table of Contents</h4>
        <ul css={styles.navMenu}>
          <VersionChooser version={version} />
          <SearchBox version={version} />
          {renderNavigationMenu(version, documentList)}
        </ul>
      </div>
    );
  }
}
